var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 164,
    viewBox: "0 0 210 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2309_26251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 164,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7364 141.733C99.2156 154.676 133.783 138.363 149.945 105.298C166.107 72.2327 157.743 34.9359 131.263 21.9933C104.784 9.05066 70.2167 25.3633 54.0549 58.4287C37.8931 91.494 46.2571 128.791 72.7364 141.733Z",
    fill: "#F2E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1898 26.623H56.6506C53.7715 26.623 51.4375 28.3532 51.4375 30.4875V47.2011C51.4375 49.3354 53.7715 51.0655 56.6506 51.0655H88.1898C91.0689 51.0655 93.4028 49.3354 93.4028 47.2011V30.4875C93.4028 28.3532 91.0689 26.623 88.1898 26.623Z",
    fill: "#CC9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9297 35.209H85.9074",
    stroke: "white",
    strokeWidth: 1.50605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9297 42.4785H85.9074",
    stroke: "white",
    strokeWidth: 1.50605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6624 66.6914H68.1232C65.2441 66.6914 62.9102 68.4216 62.9102 70.5558V87.2695C62.9102 89.4037 65.2441 91.1339 68.1232 91.1339H99.6624C102.542 91.1339 104.876 89.4037 104.876 87.2695V70.5558C104.876 68.4216 102.542 66.6914 99.6624 66.6914Z",
    fill: "#CC9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4043 75.2773H97.382",
    stroke: "white",
    strokeWidth: 1.50605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4043 82.5469H97.382",
    stroke: "white",
    strokeWidth: 1.50605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2309_26251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.519 58.0527H63.8161C58.9136 58.0527 54.9395 60.9988 54.9395 64.6329V93.0921C54.9395 96.7262 58.9136 99.6722 63.8161 99.6722H117.519C122.422 99.6722 126.396 96.7262 126.396 93.0921V64.6329C126.396 60.9988 122.422 58.0527 117.519 58.0527Z",
    fill: "#CC9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6992 71.8867H113.636",
    stroke: "white",
    strokeWidth: 3.53923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6992 85.8379H113.636",
    stroke: "white",
    strokeWidth: 3.53923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.1898 111.623H39.6506C36.7715 111.623 34.4375 113.353 34.4375 115.487V132.201C34.4375 134.335 36.7715 136.066 39.6506 136.066H71.1898C74.0689 136.066 76.4028 134.335 76.4028 132.201V115.487C76.4028 113.353 74.0689 111.623 71.1898 111.623Z",
    fill: "#CC9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9297 120.209H68.9074",
    stroke: "white",
    strokeWidth: 1.50605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9297 127.479H68.9074",
    stroke: "white",
    strokeWidth: 1.50605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.19 89.623H146.651C143.771 89.623 141.438 91.3532 141.438 93.4875V110.201C141.438 112.335 143.771 114.066 146.651 114.066H178.19C181.069 114.066 183.403 112.335 183.403 110.201V93.4875C183.403 91.3532 181.069 89.623 178.19 89.623Z",
    fill: "#CC9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93 98.209H175.907",
    stroke: "white",
    strokeWidth: 1.50605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93 105.479H175.907",
    stroke: "white",
    strokeWidth: 1.50605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.298 107.224C143.929 98.9535 147.464 82.0092 139.194 69.3779C130.923 56.7466 113.979 53.2114 101.348 61.4819C88.7163 69.7525 85.1811 86.6968 93.4517 99.3281C101.722 111.959 118.666 115.495 131.298 107.224Z",
    stroke: "black",
    strokeWidth: 11.2954,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.568 134.673L164.269 135.972C163.355 136.888 162.006 137.294 160.521 137.103C159.036 136.912 157.534 136.138 156.348 134.953L132.983 111.604C132.588 111.209 132.329 110.709 132.265 110.213C132.201 109.718 132.336 109.269 132.641 108.964L138.537 103.064C138.842 102.759 139.291 102.623 139.786 102.687C140.282 102.751 140.782 103.009 141.177 103.404L164.527 126.738C165.118 127.324 165.613 127.995 165.985 128.712C166.357 129.429 166.598 130.177 166.694 130.915C166.791 131.652 166.741 132.363 166.548 133.008C166.355 133.653 166.022 134.219 165.568 134.673Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 81.23C30.2157 81.1219 29.9231 81.1613 29.7069 81.3326L26.4125 83.9427C25.8944 84.3532 25.1366 83.9447 25.1948 83.2862L25.5638 79.1072C25.5881 78.8328 25.4605 78.5671 25.2313 78.4143L21.7077 76.0663C21.1575 75.6996 21.3131 74.8526 21.9578 74.7055L26.0682 73.7675C26.337 73.7061 26.5508 73.5027 26.6255 73.2373L27.7645 69.1901C27.9432 68.555 28.7943 68.4405 29.1346 69.0059L31.3025 72.6084C31.4446 72.8446 31.7044 72.9842 31.9798 72.9725L36.1705 72.7938C36.8298 72.7657 37.2038 73.539 36.7724 74.0384L34.0129 77.2332C33.8334 77.441 33.7812 77.7301 33.8768 77.9875L35.3375 81.922C35.5675 82.5417 34.9446 83.1359 34.3365 82.8769L30.4696 81.23Z",
    fill: "#7F00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.752 37.9125C147.407 37.6844 146.964 37.6634 146.599 37.8578L139.949 41.3958C139.074 41.8615 138.066 41.054 138.33 40.0982L140.329 32.8495C140.439 32.4512 140.323 32.0246 140.026 31.7373L134.574 26.4626C133.861 25.7729 134.32 24.5652 135.311 24.5223L142.859 24.1955C143.272 24.1777 143.642 23.9353 143.824 23.5639L147.138 16.7983C147.573 15.9095 148.86 15.9705 149.209 16.8965L151.867 23.9457C152.013 24.3325 152.359 24.6087 152.768 24.6658L160.213 25.7034C161.194 25.8401 161.537 27.0821 160.765 27.7024L154.872 32.4414C154.551 32.6996 154.396 33.112 154.467 33.5177L155.772 40.9255C155.945 41.9019 154.865 42.6104 154.038 42.0639L147.752 37.9125Z",
    fill: "#7F00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.035 154.897C119.823 154.72 119.531 154.674 119.275 154.776L116.651 155.821C116.037 156.066 115.428 155.457 115.673 154.843L116.715 152.225C116.817 151.969 116.771 151.678 116.596 151.466L114.778 149.272C114.356 148.763 114.748 147.996 115.408 148.04L118.236 148.229C118.511 148.247 118.774 148.114 118.922 147.881L120.436 145.494C120.79 144.936 121.638 145.071 121.802 145.71L122.503 148.449C122.572 148.716 122.781 148.924 123.048 148.992L125.781 149.685C126.42 149.847 126.557 150.696 126 151.05L123.604 152.577C123.373 152.725 123.24 152.987 123.257 153.261L123.439 156.075C123.482 156.734 122.715 157.125 122.206 156.702L120.035 154.897Z",
    fill: "#7F00FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2309_26251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 164,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2309_26251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.1332,
    height: 38.4044,
    fill: "white",
    transform: "translate(93.3906 61.627)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.28c78a3faeb6e7e6786128f8234e462e.svg";
export { ForwardRef as ReactComponent };